__turbopack_context__.v({
  "carouselRoot": "styles-module-scss-module__W79kfq__carouselRoot",
});
